import React from "react";
import "./MarineInsurance.scss";
import marineService from "../../../assets/Services/marine-insurance.png";
import marineImg from "../../../assets/Services/marine-img.png";

const MarineInsurance = () => {
  return (
    <>
      <div className="marine_service">
        <div className="container-fluid p-0">
          <div
            className="back_bg"
            style={{ backgroundImage: `url(${marineService})` }}
          ></div>

          <div className="heading_box">Marine Insurance</div>
          <div className="service_content">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 my-auto">
                  <div className="left mb-4 mb-lg-0">
                    <h4>Marine INSURANCES</h4>
                    <ul>
                      <li>
                        Marine Cargo, Marine Hull and Builders Risks Insurances.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-6 my-auto">
                  <img src={marineImg} className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarineInsurance;
